import React, { useCallback, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { clearExtensionStatistics, downloadStatistic, getStatisticsByParams, getInstitutionsList } from '../../actions';
import { selectStatistics, selectInstitutionsList } from '../../selectors';
import { StatisticFilterForm } from './statistic-filter-form';
import { StatisticsTable } from './statistics-table';
import './extension-statistics-style.scss';
import moment from 'moment';
const limit = 10;
export const AdminExtensionStatistics = () => {
    const { id } = useParams();
    const statistics = useSelector(selectStatistics);
    const institutions = useSelector(selectInstitutionsList);
    const [currentPage, setCurrentPage] = useState(1);
    const [filterParams, setFilterParams] = useState({
        from: moment().subtract(30, 'days'),
        to: moment(),
        institutionId: null
    });
    const dispatch = useDispatch();
    const cn = useCallback(name => {
        return `extension-statistics-${name}`;
    }, []);
    useEffect(() => {
        dispatch(getInstitutionsList());
        dispatch(clearExtensionStatistics());
    }, []);
    const getStatistics = useCallback(({ from = filterParams.from, to = filterParams.to, offset = 0, limit = 10, extensionId = id, institutionId = filterParams.institutionId }) => {
        dispatch(getStatisticsByParams({
            from: from.format('x'),
            to: to.format('x'),
            offset,
            limit,
            extensionId,
            ...(institutionId && institutionId !== null && { institutionId })
        }));
    }, [filterParams]);
    const onPageChange = useCallback((page, offset) => {
        setCurrentPage(page);
        getStatistics({
            offset
        });
    }, [filterParams]);
    const exportStatistics = useCallback(async () => {
        await dispatch(downloadStatistic({
            from: Number(filterParams.from.format('x')),
            to: Number(filterParams.to.format('x')),
            extensionId: id,
            ...(filterParams.institutionId && { institutionId: filterParams.institutionId })
        }));
    }, [filterParams]);
    const onFilterChange = useCallback(({ name, value }) => {
        setFilterParams(state => ({ ...state, [name]: value }));
        getStatistics({
            [name]: value
        });
    }, [filterParams]);
    const isStatisticsItems = !!statistics && !!statistics.list.length;
    return (<div>
      <header className="settings-header">
        <h2 className="header-title">Statistics</h2>
      </header>

      <div className={cn('header-wrapper')}>
        <StatisticFilterForm filterParams={filterParams} onChange={onFilterChange} institutions={institutions}/>
        {isStatisticsItems && (<div>
            <button onClick={exportStatistics} className={cn('export')}>
              <svg>
                <use xlinkHref="#export-users"/>
              </svg>
              <FormattedMessage id="account.meeting-history.export"/>
            </button>
          </div>)}
      </div>
      <StatisticsTable cn={cn} statistics={statistics} limit={limit} currentPage={currentPage} onPageChange={onPageChange} isStatisticsItems={isStatisticsItems}/>
    </div>);
};
